export default "__VITE_ASSET__lJTyw9mZ__"